<template>
  <!--可作为示例-->
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :before-close="cancelDialog"
    width="440px"
  >
    <el-form
      ref="addressForm"
      :model="addressForm"
      :rules="formRules"
      style="margin:10px auto;"
      @submit.native.prevent
      label-width="100px"
    >
      <el-form-item label="验证码：" prop="vCode">
        <el-input
          class="vcode-inpt"
          v-model="addressForm.vCode"
          placeholder="请输入验证码"
          type="text"
          maxlength="4"
        ></el-input>
        <canvas
          class="vcode-img"
          width="90px"
          height="30px"
          id="canvas"
        ></canvas>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="mini" type="default-mini" @click="cancelDialog"
        >取消</el-button
      >
      <el-button size="mini" type="primary-font-mini" @click="confirmAddress"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import vCodeCanvas from "@/basa/utils/vCodeCanvas";
export default {
  name: "downloadVerificationCode",
  props: {
    title: {
      type: String,
      default: "验证码"
    },
    dialogSureCallback: {
      type: Object,
      default() {
        return {};
      }
    },
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.dialogVisible;
      },
      set(val) {
        this.$emit("update:dialogVisible", val);
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          this.vCodeImg = vCodeCanvas({ el: "#canvas", height: 30, width: 90 });
        });
      }
    }
  },
  data() {
    const checkVcode = (rule, value, callback) => {
      console.log(this.vCodeImg.result, "liang");
      if (value === undefined || value === null || value === "") {
        callback(new Error("验证码不能为空"));
        return false;
      }
      if (value.toUpperCase() !== this.vCodeImg.result) {
        callback(new Error("验证码不正确"));
        return false;
      }
      callback();
      // if (!value) {
      //   callback(new Error("统一社会信用代码不能为空"));
      // } else {
      //   checkSuppilerInfo({
      //     regNum: value,
      //     checkRegNumSupCode: vm.basicInfoData.supCode
      //   }).then(res => {
      //     if (res.data.data === "RP_SP0033") {
      //       callback(new Error("该统一社会信用代码已存在"));
      //     } else {
      //       callback();
      //     }
      //   });
      // }
    };
    return {
      vCodeImg: null,
      addressForm: {
        vCode: ""
      },
      formRules: {
        vCode: [{ required: true, validator: checkVcode, trigger: "blur" }]
      }
    };
  },
  methods: {
    initData() {
      this.visible = false;
      this.addressForm.vCode = "";
    },
    cancelDialog() {
      this.$emit("cancel", false);
      this.initData();
    },
    confirmAddress() {
      this.$refs["addressForm"].validate(valid => {
        if (valid) {
          this.$emit("opSure", this.dialogSureCallback);
          this.initData();
        }
      });
    }
  },
  deactivated() {
    this.initData();
  }
};
</script>
<style scoped lang="scss">
.vcode-inpt {
  width: 200px;
}
.vcode-img {
  display: block;
  float: right;
}
</style>
